export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9177.da68926b.jpg";